import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { loginWithRedirect } = useAuth0();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="bg-black text-white py-4 fixed top-0 left-0 w-full z-50">
      <div className="container mx-auto px-4 flex items-center justify-between">
        <picture
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="cursor-pointer"
        >
          <source srcSet="/logo-sem-fundo-branca.webp" type="image/webp" />
          <img
            src="/logo-sem-fundo-branca.webp"
            alt="PedidoZ Logo"
            className="h-8 md:h-10 transition-transform duration-300 hover:scale-105"
          />
        </picture>

        {/* Desktop Navigation */}
        <div className="hidden md:flex gap-6 items-center">
          <a
            href="#features"
            className="text-white hover:text-[#FF9A3C] transition-colors relative group"
          >
            RECURSOS
            <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#FF9A3C] transition-all duration-300 group-hover:w-full"></span>
          </a>
          <a
            href="#pricing"
            className="text-white hover:text-[#FF9A3C] transition-colors relative group"
          >
            PLANOS
            <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#FF9A3C] transition-all duration-300 group-hover:w-full"></span>
          </a>
          <a
            href="#faq"
            className="text-white hover:text-[#FF9A3C] transition-colors relative group"
          >
            FAQ
            <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#FF9A3C] transition-all duration-300 group-hover:w-full"></span>
          </a>
          <button
            className="text-white hover:text-[#FF9A3C] transition-colors relative group"
            onClick={() => loginWithRedirect()}
          >
            ENTRAR
            <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#FF9A3C] transition-all duration-300 group-hover:w-full"></span>
          </button>
          <a
            href="https://wa.me/5547988355092"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-[#FF9A3C] transition-colors relative group flex items-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              viewBox="0 0 16 16"
              className="mr-1"
            >
              <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
            </svg>
            CONTATO
            <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#FF9A3C] transition-all duration-300 group-hover:w-full"></span>
          </a>
          <button
            className="bg-gradient-to-r from-[#FF9A3C] to-[#EE7B11] text-white px-6 py-2 rounded-full hover:shadow-lg hover:shadow-[#EE7B11]/30 transition-all duration-300 transform hover:-translate-y-1 font-bold"
            onClick={() => loginWithRedirect()}
          >
            COMEÇAR AGORA
          </button>
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden" onClick={toggleMenu}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>

        {/* Mobile Menu */}
        <div
          className={`md:hidden bg-gradient-to-b from-black/95 to-[#1A0A01]/95 transition-all duration-300 overflow-hidden ${
            isMenuOpen ? "max-h-60 opacity-100 py-4" : "max-h-0 opacity-0"
          }`}
        >
          <div className="container mx-auto px-4 flex flex-col gap-4">
            <a
              href="#features"
              className="text-white hover:text-[#FF9A3C] transition-colors py-2"
            >
              RECURSOS
            </a>
            <a
              href="#pricing"
              className="text-white hover:text-[#FF9A3C] transition-colors py-2"
            >
              PLANOS
            </a>
            <a
              href="#faq"
              className="text-white hover:text-[#FF9A3C] transition-colors py-2"
            >
              FAQ
            </a>
            <button
              className="text-white hover:text-[#FF9A3C] transition-colors py-2"
              onClick={() => loginWithRedirect()}
            >
              ENTRAR
            </button>
            <a
              href="https://wa.me/5547988355092"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-[#FF9A3C] transition-colors py-2 flex items-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                viewBox="0 0 16 16"
                className="mr-1"
              >
                <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
              </svg>
              CONTATO
            </a>
            <button
              className="bg-gradient-to-r from-[#FF9A3C] to-[#EE7B11] text-white px-6 py-3 rounded-full hover:shadow-lg hover:shadow-[#EE7B11]/30 transition-all duration-300 font-bold"
              onClick={() => loginWithRedirect()}
            >
              COMEÇAR AGORA
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
